<div class="flex flex-col w-full" [ngClass]="{ 'overflow-hidden': updatingTask}">
  <div class="flex items-center justify-between w-full mx-auto px-6 pt-6">
    <div class="flex items-center gap-2 text-xl md:text-2xl font-bold">
      @if (task?.taskId !== 'new') {
        <button mat-icon-button (click)="toggleUpdating('close')">
          <mat-icon class="text-current" [svgIcon]="'mat_outline:arrow_back'"></mat-icon>
        </button>
      }
      {{ service?.name }}
      @if (task?.taskId !== 'new') {
        - {{ task?.taskTypeName }} - {{ task?.taskId }}
      }
      @if (task?.taskId === 'new') {
        - {{'services.taskPlanning.newTask' | transloco}}
      }
    </div>

    <button mat-icon-button [matTooltip]="'close' | transloco" (click)="close()">
      <mat-icon class="text-current" [svgIcon]="'heroicons_outline:x'"></mat-icon>
    </button>
  </div>
  <ng-container *ngTemplateOutlet="updateTask"></ng-container>
</div>

<ng-template #updateTask>
  <form class="flex flex-col w-full mb-10" [formGroup]="taskForm">
    <div class="flex flex-col sm:flex-row p-8">
      <div class="flex flex-auto flex-wrap">
        <div class="flex flex-col w-full lg:w-1/3 sm:pl-8">
          <!-- Task Type -->
          <mat-form-field class="w-full">
            <mat-label>{{ 'taskType' | transloco }}</mat-label>
            <mat-select formControlName="taskTypeId">
              @for (group of taskTypes; track group) {
                <mat-optgroup [label]="group.value">
                  @for (taskType of group.option; track taskType) {
                    <mat-option [value]="taskType.code">
                      {{ taskType.value | localize }}
                    </mat-option>
                  }
                </mat-optgroup>
              }
            </mat-select>
          </mat-form-field>

          <!-- si selecciona tasktype, pinto el resto -->
          <!-- TASK_ASSIGNMENT -->
          @if (taskTypeData?.typology === 'TASK_ASSIGNMENT') {
            <div *ngTemplateOutlet="taskType_TaskAssignment; context: {form: taskForm}"></div>
          }
          <!-- WITHOUT_TIME -->
          @if (taskTypeData?.typology === 'WITHOUT_TIME') {
            <div *ngTemplateOutlet="taskType_WithoutTime; context: {form: taskForm}"></div>
          }
          <!-- WITH_TIME -->
          @if (taskTypeData?.typology === 'WITH_TIME') {
            <div *ngTemplateOutlet="taskType_WithTime; context: {form: taskForm}"></div>
          }

          <!-- ExternalTaskId -->
          <mat-form-field class="w-full">
            <mat-label>{{ 'externalTaskCode' | transloco }}</mat-label>
            <input matInput formControlName="externalTaskId">
          </mat-form-field>
        </div>

        @if (userZombiesCalendar || (taskTypeData && taskTypeData.dtype)) {
          <div class="flex flex-col w-full lg:w-1/3 sm:pl-8" animate.enter="appear-animation">
            <!-- Si selecciona fecha-->
            @if (userZombiesCalendar) {
              <div *ngTemplateOutlet="userZombies; context: {form: taskForm}"></div>
            }
            @if (taskTypeData && taskTypeData.dtype && taskTypeDTypeForm && !hideTaskTypeDTypeForm) {
              <div class="pt-4" animate.enter="appear-animation">
                <h2 class="text-lg font-bold">{{ 'extraFields' | transloco }}</h2>
                <div class="max-h-120 overflow-y-auto">
                  <dtype-component-list [dtypeForm]="taskTypeDTypeForm">
                  </dtype-component-list>
                </div>
              </div>
            }
          </div>
        }

        <!-- Si selecciona usuario y la tarea es con tiempo-->
        @if (taskTypeData?.typology === 'WITH_TIME') {
          <div *ngTemplateOutlet="calendar"></div>
        }
      </div>
    </div>
  </form>

    <div class="flex items-center grid grid-cols-8 w-full px-8 py-4
        absolute inset-x-0 bottom-0 border-t z-10 bg-gray-100 dark:bg-slate-900">
    @if (taskTypeData?.goals.length > 0) {
      <div class="flex items-center justify-start col-start-1 col-span-3">
        <button [disabled]="disableButton" mat-flat-button
          [color]="'primary'" (click)="addGoalsToTask()">
          {{ 'goal.addGoalsToTask' | transloco }}
        </button>
        @if (taskTypeData.goalAutoAssignment && goals.length > 0 && !autoCalculatedGoals) {
          <span class="ml-2">{{ 'goal.goalsNotCalculated' | transloco }}</span>
        }
      </div>
    }
    <div class="flex items-center justify-end col-start-9">
      @if (flashMessage) {
        <div class="flex items-center mr-4">
          @if (flashMessage === 'success') {
            <mat-icon class="text-green-500" [svgIcon]="'heroicons_outline:check'"></mat-icon>
            <span class="ml-2">{{ 'taskUpdated' | transloco }}</span>
          }
          @if (flashMessage === 'error') {
            <mat-icon class="text-red-500" [svgIcon]="'heroicons_outline:x'"></mat-icon>
            <span class="ml-2">{{ 'errorDialogMsg' | transloco }}</span>
          }
        </div>
      }
      @if (taskForm?.value.taskId !== 'new') {
        <button [disabled]="disableButton" mat-flat-button
          [color]="'primary'" (click)="updateSelectedTask()">
          {{ 'update' | transloco }}
        </button>
      }
      @if (taskForm?.value.taskId === 'new') {
        <button [disabled]="disableButton" mat-flat-button
          [color]="'primary'" (click)="updateSelectedTask()">
          {{ 'create' | transloco }}
        </button>
      }
    </div>
  </div>
</ng-template>

<ng-template #taskType_TaskAssignment  let-form="form">
  <div [formGroup]="form" animate.enter="appear-animation">
    <!-- Planning Area -->
    <mat-form-field class="w-full">
      <mat-label>{{ 'planningZone' | transloco}}</mat-label>
      <mat-select formControlName="planningAreaId">
        @for (area of planningAreas; track area) {
          <mat-option [value]="area.code">
            {{ area.value | localize }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>

    <!-- Start Date -->
    <div class="flex flex-row">
      <mat-form-field class="flex flex-col w-full items-center">
        <mat-label>{{ 'taskStartDate' | transloco }}</mat-label>
        <input readonly matInput formControlName="scheduled_from_date" [min]="$safeNavigationMigration(service?.dateFrom)"
                    [max]="(taskForm.get('scheduled_to_date')?.value && taskForm.get('scheduled_to_date')?.value !== '') ? 
                        $safeNavigationMigration(taskForm.get('scheduled_to_date')?.value) : $safeNavigationMigration(service?.dateTo)"
          [matDatepicker]="datepicker" [matDatepickerFilter]="myStartDateFilter"
          (click)="openDatepickerOnClick(datepicker)"
          [placeholder]="'startDatePlaceholder' | transloco">
          <mat-datepicker-toggle matSuffix [for]="datepicker"></mat-datepicker-toggle>
          <mat-datepicker #datepicker></mat-datepicker>
          @if (taskForm.get('scheduled_from_date').hasError('matDatepickerFilter')) {
            <mat-error>
              {{ 'invalidDate' | transloco }}
            </mat-error>
          }
        </mat-form-field>
        <!-- Start Time -->
        <div class="flex flex-col w-full items-center">
          <mat-label class="font-medium mb-2">
            {{ 'taskStartHour' | transloco }}
            <span> *</span>
          </mat-label>
          <timepicker-autofill-component [control]="taskForm.controls['scheduled_from_time']"
            [allowManual]="true" [minuteStep]="15" [style]="'HH:mm'" [spinners]="false">
          </timepicker-autofill-component>
        </div>
      </div>

      <!-- End Date -->
      <div class="flex flex-row">
        <mat-form-field class="flex flex-col w-full items-center">
          <mat-label>{{ 'taskEndDate' | transloco }}</mat-label>
          <input readonly matInput formControlName="scheduled_to_date"
            [min]="taskForm.get('scheduled_from_date')?.value ?? service?.dateFrom"
            [max]="$safeNavigationMigration(service?.dateTo)" [matDatepicker]="datepickerTo" [matDatepickerFilter]="myEndDateFilter"
            (click)="openDatepickerOnClick(datepickerTo)"
            [placeholder]="'endDatePlaceholder' | transloco">
            <mat-datepicker-toggle matSuffix [for]="datepickerTo"></mat-datepicker-toggle>
            <mat-datepicker #datepickerTo></mat-datepicker>
            @if (taskForm.get('scheduled_to_date').hasError('matDatepickerFilter')) {
              <mat-error>
                {{ 'invalidDate' | transloco }}
              </mat-error>
            }
          </mat-form-field>
          <!-- End Time -->
          <div class="flex flex-col w-full items-center">
            <mat-label class="font-medium mb-2">
              {{ 'taskEndHour' | transloco }}
              <span> *</span>
            </mat-label>
            <timepicker-autofill-component [control]="taskForm.controls['scheduled_to_time']"
              [allowManual]="true" [minuteStep]="15" [style]="'HH:mm'" [spinners]="false">
            </timepicker-autofill-component>
          </div>
        </div>
      </div>
    </ng-template>


    <ng-template #taskType_WithoutTime  let-form="form">
      <div [formGroup]="form" animate.enter="appear-animation">
        <!-- Planning Area -->
        <mat-form-field class="w-full">
          <mat-label>{{ 'planningZone' | transloco}}</mat-label>
          <mat-select formControlName="planningAreaId">
            @for (area of planningAreas; track area) {
              <mat-option [value]="area.code">
                {{ area.value | localize }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>

        <!-- Address (si hay maestro de ubicaciones) -->
        @if (taskTypeData?.locationMaster) {
          <mat-form-field class="w-full">
            <mat-label>
              {{ 'place' | transloco }}
              @if (taskTypeData?.requiresSpecificLocation) {
                <span> *</span>
              }
            </mat-label>
            <input matInput formControlName="addressOid" [matAutocomplete]="ac">
            <mat-autocomplete autoActiveFirstOption #ac="matAutocomplete" [displayWith]="displayAddress">
              @if (!taskTypeData) {
                <mat-option disabled>
                  {{ 'taskTypeRequired' | transloco}}
                </mat-option>
              }
              <!-- <mat-option *ngIf="taskForm.get('addressOid').value?.length < 3 && taskTypeData"
              disabled>
              {{ 'moreThanXCharRequired' | transloco: {value: '3'} }}
            </mat-option> -->
            @if (addressOptions?.length === 0 && taskTypeData) {
              <mat-option disabled>
                {{ 'addressNotFound' | transloco }}
              </mat-option>
            }
            @for (option of addressOptions; track option) {
              <mat-option [value]="option">
                {{ option.name }}
              </mat-option>
            }
          </mat-autocomplete>
        </mat-form-field>
      }

      <!-- Start Date -->
      <div class="flex flex-row">
        <mat-form-field class="flex flex-col w-full items-center">
          <mat-label>{{ 'taskStartDate' | transloco }}</mat-label>
          <input readonly matInput formControlName="scheduled_from_date" [min]="$safeNavigationMigration(service?.dateFrom)"
                    [max]="(taskForm.get('scheduled_to_date')?.value && taskForm.get('scheduled_to_date')?.value !== '') ? 
                        $safeNavigationMigration(taskForm.get('scheduled_to_date')?.value) : $safeNavigationMigration(service?.dateTo)"
            [matDatepicker]="datepicker" [matDatepickerFilter]="myStartDateFilter"
            (click)="openDatepickerOnClick(datepicker)"
            [placeholder]="'startDatePlaceholder' | transloco">
            <mat-datepicker-toggle matSuffix [for]="datepicker"></mat-datepicker-toggle>
            <mat-datepicker #datepicker [startView]="remote ? 'multi-year' : 'month'"></mat-datepicker>
            @if (taskForm.get('scheduled_from_date').hasError('matDatepickerFilter')) {
              <mat-error>
                {{ 'invalidDate' | transloco }}
              </mat-error>
            }
          </mat-form-field>
          <!-- Start Time -->
          <div class="flex flex-col w-full items-center">
            <mat-label class="font-medium mb-2">
              {{ 'taskStartHour' | transloco }}
              <span> *</span>
            </mat-label>
            <timepicker-autofill-component [control]="taskForm.controls['scheduled_from_time']"
              [allowManual]="true" [minuteStep]="15" [style]="'HH:mm'" [spinners]="false">
            </timepicker-autofill-component>
          </div>
        </div>

        <!-- End Date -->
        <div class="flex flex-row">
          <mat-form-field class="flex flex-col w-full items-center">
            <mat-label>{{ 'taskMaxEndDate' | transloco }}</mat-label>
            <input readonly matInput formControlName="scheduled_to_date"
              [min]="taskForm.get('scheduled_from_date')?.value ?? service?.dateFrom"
              [max]="$safeNavigationMigration(service?.dateTo)" [matDatepicker]="datepickerTo" [matDatepickerFilter]="myEndDateFilter"
              (click)="openDatepickerOnClick(datepickerTo)"
              [placeholder]="'endDatePlaceholder' | transloco">
              <mat-datepicker-toggle matSuffix [for]="datepickerTo"></mat-datepicker-toggle>
              <mat-datepicker #datepickerTo></mat-datepicker>
              @if (taskForm.get('scheduled_to_date').hasError('matDatepickerFilter')) {
                <mat-error>
                  {{ 'invalidDate' | transloco }}
                </mat-error>
              }
            </mat-form-field>
            <!-- End Time -->
            <div class="flex flex-col w-full items-center">
              <mat-label class="font-medium mb-2">
                {{ 'taskEndHour' | transloco }}
                <span> *</span>
              </mat-label>
              <timepicker-autofill-component [control]="taskForm.controls['scheduled_to_time']"
                [allowManual]="true" [minuteStep]="15" [style]="'HH:mm'" [spinners]="false">
              </timepicker-autofill-component>
            </div>
          </div>
        </div>
      </ng-template>


      <ng-template #taskType_WithTime let-form="form">
        <div [formGroup]="form" animate.enter="appear-animation">
          <!-- Planning Area -->
          <mat-form-field class="w-full">
            <mat-label>{{ 'planningZone' | transloco}}</mat-label>
            <mat-select formControlName="planningAreaId">
              @for (area of planningAreas; track area) {
                <mat-option [value]="area.code">
                  {{ area.value | localize }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>

          <!-- Address (si hay maestro de ubicaciones) -->
          @if (taskTypeData?.locationMaster) {
            <mat-form-field class="w-full">
              <mat-label>
                {{ 'place' | transloco }}
                @if (taskTypeData?.requiresSpecificLocation) {
                  <span> *</span>
                }
              </mat-label>
              <input matInput formControlName="addressOid" [matAutocomplete]="ac">
              <mat-autocomplete autoActiveFirstOption #ac="matAutocomplete" [displayWith]="displayAddress">
                @if (!taskTypeData) {
                  <mat-option disabled>
                    {{ 'taskTypeRequired' | transloco}}
                  </mat-option>
                }
                <!-- <mat-option *ngIf="taskForm.get('addressOid').value?.length < 3 && taskTypeData"
                disabled>
                {{ 'moreThanXCharRequired' | transloco: {value: '3'} }}
              </mat-option> -->
              @if (addressOptions?.length === 0 && taskTypeData) {
                <mat-option disabled>
                  {{ 'addressNotFound' | transloco }}
                </mat-option>
              }
              @for (option of addressOptions; track option) {
                <mat-option [value]="option">
                  {{ option.name }}
                </mat-option>
              }
            </mat-autocomplete>
          </mat-form-field>
        }

        <!-- WorkDay (si hay maestro de tipos)-->
        @if (workDayData?.length > 0) {
          <mat-form-field class="w-full">
            <mat-label>{{ 'workDay' | transloco}}</mat-label>
            <mat-select formControlName="workDayOid">
              <mat-option [value]="">
                {{ 'noSelection' | transloco }}
              </mat-option>
              @for (w of workDayData; track w) {
                <mat-option [value]="w._oid">
                  {{ w.description | localize }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        }

        <!-- Start Date -->
        <div class="flex">
          <mat-form-field class="w-full">
            <mat-label>{{ 'taskStartDate' | transloco }}</mat-label>
            <input readonly matInput formControlName="scheduled_from_date" [min]="$safeNavigationMigration(service?.dateFrom)"
                    [max]="(taskForm.get('scheduled_to_date')?.value && taskForm.get('scheduled_to_date')?.value !== '') ? 
                        $safeNavigationMigration(taskForm.get('scheduled_to_date')?.value) : $safeNavigationMigration(service?.dateTo)"
              [matDatepicker]="datepicker" [matDatepickerFilter]="myStartDateFilter"
              (click)="openDatepickerOnClick(datepicker)"
              [placeholder]="'startDatePlaceholder' | transloco">
              <mat-datepicker-toggle matSuffix [for]="datepicker"></mat-datepicker-toggle>
              <mat-datepicker #datepicker [startView]="remote ? 'multi-year' : 'month'"></mat-datepicker>
              @if (taskForm.get('scheduled_from_date').hasError('matDatepickerFilter')) {
                <mat-error>
                  {{ 'invalidDate' | transloco }}
                </mat-error>
              }
            </mat-form-field>
          </div>

          <!-- Horas según el tipo de jornada -->
          <!-- Sin tipo de jornada o NONE-->
          @if (workDay?.mode === 'NONE' || !this.workDay?.mode) {
            <div *ngTemplateOutlet="workdayType_None"></div>
          }

          <!-- Tipo SPLIT -->
          @if (workDay?.mode === 'SPLIT') {
            <div *ngTemplateOutlet="workdayType_Split"></div>
          }

          <!-- Tipo MINUTES -->
          @if (workDay?.mode === 'MINUTES') {
            <div *ngTemplateOutlet="workdayType_Minutes"></div>
          }

          <!-- Tipo SPECIFIC_SCHEDULE -->
          @if (this.workDay?.mode === 'SPECIFIC_SCHEDULE') {
            <div *ngTemplateOutlet="workdayType_SpecificSchedule"></div>
          }
        </div>
      </ng-template>


      <ng-template #workdayType_None>
        <div class="flex flex-col sm:flex-row lg:flex-col 2xl:flex-row" animate.enter="appear-animation">
          <!-- Start Time -->
          <div class="mb-4 flex flex-col w-full items-center">
            <mat-label class="font-medium mb-1">
              {{ 'taskStartHour' | transloco }}
              @if (taskTypeData?.requiresPlanningStartTime) {
                <span> *</span>
              }
            </mat-label>
            <timepicker-autofill-component [control]="taskForm.controls['scheduled_from_time']"
              [allowManual]="true" [minuteStep]="15" [style]="'HH:mm'" [spinners]="false">
            </timepicker-autofill-component>
          </div>
          <!-- End Time -->
          <div class="mb-4 flex flex-col w-full items-center">
            <mat-label class="font-medium mb-1">
              {{ 'taskEndHour' | transloco }}
              @if (taskTypeData?.requiresPlanningEndTime) {
                <span> *</span>
              }
            </mat-label>
            <timepicker-autofill-component [control]="taskForm.controls['scheduled_to_time']"
              [allowManual]="true" [minuteStep]="15" [style]="'HH:mm'" [spinners]="false">
            </timepicker-autofill-component>
          </div>
        </div>
      </ng-template>


      <ng-template #workdayType_Split>
        <div class="flex flex-col sm:flex-row lg:flex-col 2xl:flex-row" animate.enter="appear-animation">
          <!-- Start Time -->
          <div class="mb-2 flex flex-col w-full items-center">
            <mat-label class="font-medium mb-1">
              {{ 'taskStartHour' | transloco }}
              <span>(1) *</span>
            </mat-label>
            <timepicker-autofill-component [control]="taskForm.controls['scheduled_from_time']"
              [allowManual]="true" [minuteStep]="15" [style]="'HH:mm'" [spinners]="false">
            </timepicker-autofill-component>
          </div>
          <!-- End Time -->
          <div class="mb-2 flex flex-col w-full items-center">
            <mat-label class="font-medium mb-1">
              {{ 'taskEndHour' | transloco }}
              <span>(1) *</span>
            </mat-label>
            <timepicker-autofill-component [control]="taskForm.controls['scheduled_to_time']"
              [allowManual]="true" [minuteStep]="15" [style]="'HH:mm'" [spinners]="false">
            </timepicker-autofill-component>
          </div>
        </div>
        <div class="flex flex-col sm:flex-row lg:flex-col 2xl:flex-row" animate.enter="appear-animation">
          <!-- Start Time2 -->
          <div class="mb-4 flex flex-col w-full items-center">
            <mat-label class="font-medium mb-1">
              {{ 'taskStartHour' | transloco }}
              <span>(2) *</span>
            </mat-label>
            <timepicker-autofill-component [control]="taskForm.controls['scheduled_from_time2']"
              [allowManual]="true" [minuteStep]="15" [style]="'HH:mm'" [spinners]="false">
            </timepicker-autofill-component>
          </div>
          <!-- End Time2 -->
          <div class="mb-4 flex flex-col w-full items-center">
            <mat-label class="font-medium mb-1">
              {{ 'taskEndHour' | transloco }}
              <span>(2) *</span>
            </mat-label>
            <timepicker-autofill-component [control]="taskForm.controls['scheduled_to_time2']"
              [allowManual]="true" [minuteStep]="15" [style]="'HH:mm'" [spinners]="false">
            </timepicker-autofill-component>
          </div>
        </div>
      </ng-template>


      <ng-template #workdayType_SpecificSchedule>
        <div class="flex flex-col sm:flex-row lg:flex-col 2xl:flex-row" animate.enter="appear-animation">
          <!-- Start Time -->
          <div class="mb-4 flex flex-col w-full items-center">
            <mat-label class="font-medium mb-1">
              {{ 'taskStartHour' | transloco }}
              <span> *</span>
            </mat-label>
            <timepicker-autofill-component [control]="taskForm.controls['scheduled_from_time']"
              [allowManual]="true" [minuteStep]="15" [style]="'HH:mm'" [spinners]="false">
            </timepicker-autofill-component>
          </div>
          <!-- End Time -->
          <div class="mb-4 flex flex-col w-full items-center">
            <mat-label class="font-medium mb-1">
              {{ 'taskEndHour' | transloco }}
              <span> *</span>
            </mat-label>
            <timepicker-autofill-component [control]="taskForm.controls['scheduled_to_time']"
              [allowManual]="true" [minuteStep]="15" [style]="'HH:mm'" [spinners]="false">
            </timepicker-autofill-component>
          </div>
        </div>
      </ng-template>


      <ng-template #workdayType_Minutes>
        <div class="flex flex-col sm:flex-row lg:flex-col 2xl:flex-row" animate.enter="appear-animation">
          <!-- Start Time -->
          <div class="mb-4 flex flex-col w-full items-center">
            <mat-label class="font-medium mb-1">
              {{ 'taskStartHour' | transloco }}
              <span> *</span>
            </mat-label>
            <timepicker-autofill-component [control]="taskForm.controls['scheduled_from_time']"
              [allowManual]="true" [minuteStep]="15" [style]="'HH:mm'" [spinners]="false">
            </timepicker-autofill-component>
          </div>
          <!-- End Time -->
          <div class="mb-4 flex flex-col w-full items-center">
            <mat-label class="font-medium mb-1">
              {{ 'taskEndHour' | transloco }}
              <span> *</span>
            </mat-label>
            <timepicker-autofill-component [control]="taskForm.controls['scheduled_to_time']"
              [allowManual]="true" [minuteStep]="15" [style]="'HH:mm'" [spinners]="false">
            </timepicker-autofill-component>
          </div>
        </div>
      </ng-template>

      <ng-template #userZombies let-form="form">
        <div class="flex flex-col w-full" [formGroup]="form" animate.enter="appear-animation">
          <!-- Zombies -->
          @if (!service?.generateUsernamesManually && service?.genericApplicationName !== GenericApplicationName.weldon) {
            <mat-form-field class="w-full">
              <mat-label [ngClass]="{'selectbg1': autoZombie}">{{ (autoZombie ? 'defaultResource' : 'resource') | transloco }}</mat-label>
              <input matInput formControlName="zombie" [matAutocomplete]="acZombie" />
              @if (taskForm.get('zombie').value) {
                <button matSuffix mat-icon-button aria-label="Clear"
                  (click)="taskForm.get('zombie').setValue('')">
                  <mat-icon>close</mat-icon>
                </button>
              }
              <mat-autocomplete #acZombie="matAutocomplete" [displayWith]="displayValueZombie">
                @for (zombie of filteredZombies | async; track zombie) {
                  <mat-option [value]="zombie">
                    {{ zombie.name | localize }}
                  </mat-option>
                }
              </mat-autocomplete>
            </mat-form-field>
          }

          <!-- Users -->
          <mat-form-field class="w-full">
            <mat-label [ngClass]="{'selectbg1': autoUser}">{{ (autoUser ? 'defaultUser' : 'user') | transloco }}</mat-label>
            <input matInput formControlName="user" [matAutocomplete]="acUser" />
            @if (taskForm.get('user').value) {
              <button matSuffix mat-icon-button aria-label="Clear"
                (click)="taskForm.get('user').setValue('')">
                <mat-icon>close</mat-icon>
              </button>
            }
            <mat-autocomplete #acUser="matAutocomplete" [displayWith]="displayValueUser">
              @for (user of filteredUsers | async; track user) {
                <mat-option [value]="user">
                  {{ user.fullname | localize }}
                </mat-option>
              }
            </mat-autocomplete>
          </mat-form-field>

          @if (selectedUser?.userId) {
            <div class="flex items-center">
              @if (selectedUser?.trained) {
                <div>
                  <div class="flex items-center">{{ 'services.resources.thisUserIsTrained' | transloco }}
                    <button class="bg-transparent icon-button-small -my-4" mat-icon-button
                      (click)="changeTrained($event, selectedUser)">
                      <mat-icon [svgIcon]="'feather:award'" class="green-icon"
                        matTooltip="{{ 'services.resources.isTrained' | transloco }}"
                        matTooltipPosition="right">
                      </mat-icon>
                    </button>
                  </div>
                </div>
              }
              @if (!selectedUser?.trained) {
                <div>
                  <div class="flex items-center">{{ 'services.resources.thisUserIsNotTrained' | transloco }}
                    <button class="bg-transparent icon-button-small -my-4" mat-icon-button
                      (click)="changeTrained($event, selectedUser)">
                      <mat-icon [svgIcon]="'feather:alert-circle'" class="red-icon"
                        matTooltip="{{ 'services.resources.isNotTrained' | transloco }}"
                      matTooltipPosition="right"></mat-icon>
                    </button>
                  </div>
                </div>
              }
            </div>
          }

          @if (selectedZombie && selectedUser && selectedZombie.zombieNumber !== selectedUser.zombieNumber && selectedUser.userId && selectedZombie.zombieNumber > 0) {
            <mat-checkbox
              class="mt-2" [checked]="changeUserZombieLink" (change)="changeUserZombieCheck($event.checked)">
            {{ 'changeZombieUserLink' | transloco}}</mat-checkbox>
          }
        </div>
      </ng-template>


      <ng-template #calendar>
        @if (animateCalendar) {
          <div class="flex flex-col w-full lg:w-1/3 sm:pl-8" animate.enter="appear-animation">
            @if (selectedDayUserTasks?.length > 0) {
              <mat-label class="w-full bg-primary text-on-primary p-2">{{ $safeNavigationMigration(selectedDayUserTasks[0]?.date) |
              date: 'fullDate' }}</mat-label>
              @for (task of selectedDayUserTasks; track task) {
                <div class="tasks-grid grid items-center gap-4 py-3 px-4 md:px-6 border-b bg-white dark:bg-transparent"
                  >
                  <div>{{ task.numberOfTasks }} {{ (task.numberOfTasks === 1 ? 'taskOf' : 'tasksOf') |
                  transloco }} {{ task.taskTypeName }}</div>
                  @if (task.fromTime && task.toTime) {
                    <div>{{ 'from' | transloco }} {{ task.fromTime }} {{
                    'to' | transloco | lowercase }} {{ task.toTime }}</div>
                  }
                  @if (task.fromTime && !task.toTime) {
                    <div>{{ 'from' | transloco }} {{ task.fromTime }}
                    </div>
                  }
                  @if (!task.fromTime && task.toTime) {
                    <div>{{ 'to' | transloco }} {{ task.toTime }}</div>
                  }
                </div>
              }
            }
            @if (nextDayUserTasks?.length > 0) {
              <mat-label class="w-full bg-primary mt-0 text-on-primary p-2">{{ $safeNavigationMigration(nextDayUserTasks[0]?.date) |
              date: 'fullDate' }}</mat-label>
              @for (task of nextDayUserTasks; track task) {
                <div class="tasks-grid grid items-center gap-4 py-3 px-4 md:px-6 border-b bg-white dark:bg-transparent"
                  >
                  <div>{{ task.numberOfTasks }} {{ (task.numberOfTasks === 1 ? 'taskOf' : 'tasksOf') |
                  transloco }} {{ task.taskTypeName }}</div>
                  @if (task.fromTime && task.toTime) {
                    <div>{{ 'from' | transloco }} {{ task.fromTime }} {{
                    'to' | transloco | lowercase }} {{ task.toTime }}</div>
                  }
                  @if (task.fromTime && !task.toTime) {
                    <div>{{ 'from' | transloco }} {{ task.fromTime }}
                    </div>
                  }
                  @if (!task.fromTime && task.toTime) {
                    <div>{{ 'to' | transloco }} {{ task.toTime }}</div>
                  }
                </div>
              }
            }
            @if (selectedDayUserTasks?.length === 0 && nextDayUserTasks?.length === 0 && (selectedZombie?.zombieNumber > 0 || selectedUser?.userId)) {
              <mat-label class="w-full bg-primary text-on-primary p-2">{{ 'tasks' | transloco }}</mat-label>
              <div
                class="tasks-grid grid items-center gap-4 py-3 px-4 md:px-6 border-b bg-white dark:bg-transparent">
                <div>{{ 'emptyCalendar' | transloco }}</div>
              </div>
            }
            @if (selectedDayAbsence?.isAbsence) {
              <fuse-alert
                [type]="'warning'"
                [appearance]="'border'">
                <span fuseAlertTitle>{{ 'warning' | transloco }}</span>
                {{ 'services.absences.userIsAbsent' | transloco }}
                @if (selectedDayAbsence.fromTime && selectedDayAbsence.toTime) {
                  &nbsp;{{ 'from' | transloco | lowercase }} {{ selectedDayAbsence.fromTime }} {{ 'to' | transloco | lowercase }} {{ selectedDayAbsence.toTime }}
                }
              </fuse-alert>
            }
            @if (selectedDayIsHoliday) {
              <fuse-alert
                [type]="'warning'"
                [appearance]="'border'">
                <span fuseAlertTitle>{{ 'warning' | transloco }}</span>
                {{ 'services.planning.holidayByCalendar' | transloco }}
              </fuse-alert>
            }
          </div>
        }
      </ng-template>